import { render, staticRenderFns } from "./PlateDatepickerForm.vue?vue&type=template&id=54ec72a3&scoped=true&"
import script from "./PlateDatepickerForm.vue?vue&type=script&lang=js&"
export * from "./PlateDatepickerForm.vue?vue&type=script&lang=js&"
import style0 from "./PlateDatepickerForm.vue?vue&type=style&index=0&id=54ec72a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec72a3",
  null
  
)

export default component.exports